import { render, staticRenderFns } from "./LivingBoxComponent.vue?vue&type=template&id=4d60e042&scoped=true&"
import script from "./LivingBoxComponent.vue?vue&type=script&lang=js&"
export * from "./LivingBoxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60e042",
  null
  
)

export default component.exports